
export const ALERT_STATUS = {
    NOVISTA     : '100', //  No vista, ni por la policia ni por el usuario
    VISTAUSER   : '200', //  requiere NOVISTA, o VISTAPOLICIA
    VISTAPOLICIA: '300', // requiere NOVISTA o VISTAUSUARIO
    VISTA       : '999', // requiere vista  por el usuario y policia
}
